import { createSelector } from '@ngrx/store';

import { getFeatureToggleState } from '../../reducers';

export const selectBeneByRelationToggleState = createSelector(
  getFeatureToggleState,
  (state) => state.benes_by_relation,
);
export const selectControlPersonFeatureToggle = createSelector(
  getFeatureToggleState,
  (state) => state.control_person,
);
export const selectGiftingToggle = createSelector(getFeatureToggleState, (state) => state.gifting);
export const selectGiftingScaleToggleV2 = createSelector(
  getFeatureToggleState,
  (state) => state.gifting_scale_v2,
);
export const selectInheritedTraditionalIRAToggle = createSelector(
  getFeatureToggleState,
  (state) => state.cwp_ira_scale_trad,
);
export const selectInheritedRothIRAToggle = createSelector(
  getFeatureToggleState,
  (state) => state.cwp_ira_scale_inh_roth,
);
export const selectITJointToggle = createSelector(
  getFeatureToggleState,
  (state) => state.internal_transfer_joint,
);
export const selectITTrustToggle = createSelector(
  getFeatureToggleState,
  (state) => state.internal_transfer_trust,
);
export const selectUpdatedMXMToggle = createSelector(
  getFeatureToggleState,
  (state) => state.cwp_updated_mxm_enablement,
);
export const selectIRAEstateToggle = createSelector(
  getFeatureToggleState,
  (state) => state.cwp_ira_scale_estate,
);
export const selectIRAInheritedRothToggle = createSelector(
  getFeatureToggleState,
  (state) => state.cwp_ira_scale_inh_roth,
);
export const selectIRAInheritedTraditionalToggle = createSelector(
  getFeatureToggleState,
  (state) => state.cwp_ira_scale_trad,
);
export const selectIRATrustToggle = createSelector(
  getFeatureToggleState,
  (state) => state.cwp_ira_scale_trust,
);
export const selectInheritanceJoint = createSelector(
  getFeatureToggleState,
  (state) => state.joint_inheritance,
);
export const selectInheritanceIndividual = createSelector(
  getFeatureToggleState,
  (state) => state.inheritance_individual,
);
export const selectInheritanceIRA = createSelector(
  getFeatureToggleState,
  (state) => state.inheritance_ira,
);
export const selectTrustToTrustToggle = createSelector(
  getFeatureToggleState,
  (state) => state.cwp_ira_scale_trust_to_trust,
);
export const selectInternalGiftingManagedAccountsToggle = createSelector(
  getFeatureToggleState,
  (state) => state.cwp_internal_gifting_managed_accounts,
);
export const selectIntelledoxAndRedirectRemovalToggle = createSelector(
  getFeatureToggleState,
  (state) => state.intelledox_redirect_and_thresholds,
);
export const selectCashPlusInternalTransferToggle = createSelector(
  getFeatureToggleState,
  (state) => state.cash_plus_internal_transfer,
);
export const selectVCDSettlementFundsToggle = createSelector(
  getFeatureToggleState,
  (state) => state.vcd_settlement_funds,
);
export const selectDocumentChecklistToggle = createSelector(
  getFeatureToggleState,
  (state) => state.doc_checklist_inheritance,
);
export const selectMultiInheritanceToggle = createSelector(
  getFeatureToggleState,
  (state) => state.cwp_multi_inheritance,
);
export const selectITEstateScaleToggle = createSelector(
  getFeatureToggleState,
  (state) => state.cwp_it_estate_scale,
);

export const selectITUgmaUtmaToggle = createSelector(
  getFeatureToggleState,
  (state) => state.cwp_ugma_utma_it,
);

export const selectMinorCO0Toggle = createSelector(
  getFeatureToggleState,
  (state) => state.cwp_co0_minor,
);

export const selectInheritanceCO0Toggle = createSelector(
  getFeatureToggleState,
  (state) => state.cwp_co0_inheritance,
);

export const selectInternalTransferCO0Toggle = createSelector(
  getFeatureToggleState,
  (state) => state.cwp_co0_internal_transfers,
);

export const selectCO0UploadToggle = createSelector(
  getFeatureToggleState,
  (state) => state.cwp_co0_upload,
);

export const selectToFromConsolidationToggle = createSelector(
  getFeatureToggleState,
  (state) => state.to_from_consolidation,
);

export const selectGiftingCO0Toggle = createSelector(
  getFeatureToggleState,
  (state) => state.cwp_co0_gifting,
);

export const selectDivorceToggle = createSelector(
  getFeatureToggleState,
  (state) => state.cwp_divorce,
);
